module.exports = __webpack_public_path__ + "images/icon/delete_16_on-b85b5c88.svg";